<template>
  <v-container grid-list-md>
    <v-sheet elevation="1" class="header-bar">
      <v-layout row class="align-center justify-start d-flex-initial">
        <v-flex class="mr-2" v-if="$mq === 'lg'">
          <v-btn flat @click="$router.back()" color="primary">
            <v-icon>arrow_left</v-icon>Retour
          </v-btn>
        </v-flex>
        <v-flex :style="{ position: 'relative', top: '-3px' }">
          <div class="mr-2 text-uppercase mt-1 d-inline-block">
            {{ host && host.address }}
          </div>
          |
          <div
            class="ml-2 mt-1 d-inline-block"
            :style="{ position: 'relative' }"
          >
            {{ host && host._id }}
          </div>
        </v-flex>
      </v-layout>
    </v-sheet>

    <v-layout row v-if="host === null">
      <v-flex xs12 class="d-flex justify-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-else class="mt-2" style="position: relative">
      <v-flex xs12 lg8>
        <v-card class="px-2 py-2">
          <HostDetails :id="$route.params.id" :edit-mode="true" />
        </v-card>
      </v-flex>
      <v-flex xs12 lg4>
        <v-card class="px-1 py-1">
          <h3>Dossiers proposés</h3>
          <v-list v-if="proposals && proposals.length > 0">
            <v-list-tile
              v-for="p in proposals"
              :key="p._id"
              @click="$router.push(`/project/${p._lease._id}`)"
            >
              <v-list-tile-content>
                {{ p._lease.userId }}
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon>arrow_right</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <div class="notice" v-else>Pas de propositions associées</div>
        </v-card>
        <v-card class="px-1 py-1 mt-2">
          <h3>Ajouter à un dossier</h3>
          <div class="ml-3 mr-1 mt-3">
            <v-autocomplete
              v-model="targetProject"
              :items="projects"
              persistent-hint
              label="Dossier"
              hint="Nom ou mail"
            >
            </v-autocomplete>
          </div>
          <div class="d-flex justify-end ml-2 mt-3 mb-1">
            <v-btn :disabled="targetProject == null" @click="addHostToProject"
              >Ajouter</v-btn
            >
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { fetchHil, fetchHil2 } from "../utils";
import HostDetails from "../components/hosts/HostDetails";
import { addDistancesToProposal } from "../services/maps";
import { mapActions, mapState } from "vuex";

export default {
  name: "Host",
  components: {
    HostDetails
  },
  data: function() {
    return {
      editMode: false,
      host: null,
      hostOrig: null,
      targetProject: null,
      projects: []
    };
  },
  async mounted() {
    let id = this.$route.params.id;
    const resp = await (await fetchHil(`/hosts/${id}`)).json();
    this.setHost(resp);
    this.fetchLeasesForHost({ id });
    this.fetchProjects();
  },
  methods: {
    ...mapActions("hosts", ["fetchLeasesForHost"]),
    async fetchProjects() {
      const resp = await fetchHil2("POST", "/leases", {
        body: {
          properties: "firstName lastName _id",
          size: 10000,
          offset: 0,
          filter: "active"
        }
      });
      this.projects = resp.map(lease => ({
        text: `${lease.firstName} ${lease.lastName}`,
        value: lease
      }));
    },
    setHost(host) {
      const resp = { ...host };
      resp.userId = undefined;
      this.host = resp;
      this.hostSave = { ...resp };
    },
    cancel() {
      this.host = { ...this.hostOrig };
      this.editMode = false;
    },
    async addHostToProject() {
      try {
        const resp = await fetchHil(
          `/proposals/lease/${this.targetProject._id}/host/${this.host._id}`,
          { method: "POST" }
        );
        if (!resp.ok) {
          console.error(await resp.text());
          this.showError = true;
        }
        this.fetchLeasesForHost({
          id: this.host._id
        });
        await addDistancesToProposal(this.targetProject, this.host);
        this.targetProject = null;
      } catch (err) {
        console.error(err);
        this.showError = true;
      }
    }
  },
  computed: {
    ...mapState("hosts", ["currentHostProjects"]),
    proposals() {
      this.currentHostProjects.forEach(({ _lease, idBuy }) => {
        if (_lease == null) {
          console.warn("unknown lease : " + idBuy);
        }
      });
      return this.currentHostProjects
        ? this.currentHostProjects.filter(({ _lease }) => _lease != null)
        : [];
    }
  }
};
</script>

<style scoped>
h2 {
  text-transform: uppercase;
  font-size: 12pt;
  padding-left: 8px;
}

.property-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  display: block;
  text-align: right;
}

.property-value a {
  font-size: 0.8rem;
}
</style>
